<template>
  <main id="fullpage">
    <header-slide></header-slide>
    <idea-slide></idea-slide>
    <club-slide></club-slide>
    <support-slide></support-slide>
    <blog-slide></blog-slide>
  </main>
</template>

<script>
import TweenMax from 'gsap';
import $ from 'jquery';
import 'fullpage.js';
import 'jquery.easing';
import HeaderSlide from './HeaderSlide';
import IdeaSlide from './IdeaSlide';
import ClubSlide from './ClubSlide';
import SupportSlide from './SupportSlide';
import BlogSlide from './BlogSlide';

export default {
  name: 'TopPage',
  components: {
    HeaderSlide,
    IdeaSlide,
    ClubSlide,
    SupportSlide,
    BlogSlide,
  },

  mounted() {
    this.fullPage();
  },

  methods: {
    fullPage() {
      $(() => {
        if ($('body').width() >= 1024) {
          TweenMax.set('.section', {
            transformPerspective: 600,
            rotationX: '-60',
            transformOrigin: 'center top',
            opacity: 0,
          });
          $('#fullpage').fullpage({
            sectionSelector: '.start, .section',
            responsiveWidth: 1024,
            navigation: true,
            navigationPosition: 'right',
            navigationTooltips: ['おやこハグネット', '理念', '放課後児童クラブ', '児童家庭支援事業', 'おやこハグ日記'],
            // eslint-disable-next-line
            onLeave: function (index, nextIndex, direction) {
              const beforeSlides = $(this).prevAll();
              if (direction === 'up') {
                TweenMax.to(beforeSlides, 0.5, {
                  rotationX: 0,
                  opacity: 1,
                });
                TweenMax.to(this, 0.5, {
                  transformPerspective: 600,
                  rotationX: '-60',
                  opacity: 0,
                  delay: 0.5,
                });
              }
            },
            // eslint-disable-next-line
            afterLoad: function (anchorLink, index) {
              const afterSlides = $(this).nextAll();
              TweenMax.to(this, 0.5, {
                rotationX: 0,
                opacity: 1,
              });
              TweenMax.to(afterSlides, 0.5, {
                transformPerspective: 600,
                rotationX: '-60',
                opacity: 0,
              });
            },
          });
        }
      });
    },
  },
};

</script>

<style src="fullpage.js/dist/jquery.fullpage.css"></style>
<style lang="scss">
  @import '../assets/stylesheets/_mixin.scss';
  @include media( sm ) {
    .fullpage-wrapper {
    	width: 100%!important;
    	transform: none!important;
    }

    .fp-section {
    	width: 100%!important;
    	position: absolute;
    	left: 0;
    	top: 0;
    	z-index: 1;
      // transition: z-index 0.5s ease 0.5s;
    }

    .fp-section:not(:first-child) {
      // opacity: 0;

    }

    .fp-section.active {
    	// z-index: 10;
    }

    $navColors: #fff, #ffc3c3, #ffc899, #98e5ff, #f5ff8e;

    @each $navColor in $navColors {
      $i: index($navColors, $navColor);
      #fp-nav ul li:nth-child(#{$i}) a span {
        background: $navColor;
      }
    }

    #fp-nav ul li {
      margin: 14px;
      a {
        span {
          border: 1px solid #aaa;
          width: 10px;
          height: 10px;
        }
        &.active {
          span {
            width: 16px;
            height: 16px;
            margin: -5px 0 0 -5px;
          }
        }
      }
      &:hover {
        a {
          span {
            width: 16px;
            height: 16px;
            margin: -5px 0 0 -5px;
          }
          &.active {
            span {
              width: 16px;
              height: 16px;
              margin: -5px 0 0 -5px;
            }
          }
        }
      }
      .fp-tooltip {
        color: #666;
        top: 3px;
        &.right {
          right: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TopPage.vue?7e4789bc